// istanbul ignore file
import { Card, CircularProgress, Grid, Typography, Checkbox, Box, TextField, IconButton } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import './dashboard.css'
import HighchartsReact from 'highcharts-react-official'
import DarkUnica from 'highcharts/themes/dark-unica'
import * as HighCharts from 'highcharts'
import { GenXDropdown, type Option } from '../../../components/GenXDropdown'
import { viewDeviceService } from '../../device-management/services/viewDeviceService'
import extentWindow from '../../../assets/extendClick.svg'
import EditIcon from '../../../assets/Edit.svg'
import { saveDefaultViewDataservice, fetchflameSignalDataNEWONE, fetchflameKPISignalData } from '../redux/actionCreator'
import { type flameSignalReadingDataState } from '../redux/getFlameSignaGraphDataSlice'
import { type IFlameSignalDataState } from '../redux/getFlameSignaGraphDataSliceNew'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import { type SaveDefaultViewRequest } from '../services/saveDeafultViewService'
import { type SaveDefaultViewDataState } from '../redux/saveDefaultViewSlice'
import { type exportDeviceDataGraphDataState } from '../redux/exportGraphSlice'
import AuthError from '../../../components/ErrorComponents/AuthError'
import Modal from '../../../components/Modal'
import CloseIcon from '@mui/icons-material/Close'
import Exporting from 'highcharts/modules/exporting'
import ExportData from 'highcharts/modules/export-data'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { updateSaveDefaultObject } from '../../../utils/updateSaveDefaultObject'
import { getChartOptions, type IConfigObject } from './ChartSetup'
import { useOutletContext } from 'react-router-dom'
import { MemorizedExport } from '../../services/components/ExportGraphData'
import { DEFAULT_DATA_WINDOW_HOURS } from '../../../utils/DashboardContants'

dayjs.extend(utc)
Exporting(HighCharts)
ExportData(HighCharts)

const defaultConfigObj: IConfigObject = {
  1: {
    serialNumber: '1',
    checked: false,
    color: '#9AB7FF',
    selectedSignalData: null
  },
  2: {
    serialNumber: '2',
    checked: false,
    color: '#FFF55D',
    selectedSignalData: null
  },
  3: {
    serialNumber: '3',
    checked: false,
    color: '#F2752C',
    selectedSignalData: null
  },
  4: {
    serialNumber: '4',
    checked: false,
    color: '#19CB35',
    selectedSignalData: null
  }
}

const flameSignalGraph = (props: AllProps): JSX.Element => {
  const [configObject, setConfigObject] = React.useState(defaultConfigObj)
  const parameterList = React.useRef<any>([])
  const kpiList = React.useRef<any>([])
  const chartComponentRef = React.useRef<any>(null)
  const chartComponentRef1 = React.useRef<any>(null)
  const [signalOptions, setSignalOptions] = React.useState<Option[]>([])
  const [showAddModal, setShowAddModal] = React.useState(false)
  const [isEditing, setIsEditing] = React.useState(false)
  const [text, setText] = React.useState('DeviceGraph1')
  const selectedData = React.useRef<any>(null)
  const saveDefaultViewObject = useSelector((state: RootState) => state.saveDefaultViewObject.saveDefaultViewObject)
  const { sidebarCollapsed } = useOutletContext<{ sidebarCollapsed: boolean }>() ?? { sidebarCollapsed: false }
  const dashboardHours = DEFAULT_DATA_WINDOW_HOURS

  // Reflow chart when sidebar state changes
  React.useEffect(() => {
    // Wait for DOM/layout changes before reflow
    setTimeout(() => {
      const chart = chartComponentRef.current?.chart
      if (chart !== null && chart !== undefined) {
        chart.reflow()
      }
    }, 350) // Slightly increased delay for smoother sidebar animation
  }, [sidebarCollapsed])

  const formattedResponseKPIRef = useRef<any>(null)
  const handleEditClick = (): void => {
    setIsEditing(true)
  }

  React.useEffect(() => {
    setConfigObject(defaultConfigObj)
  }, [props.deviceIdCurrent])

  React.useEffect(() => {
    setConfigObject(defaultConfigObj)
  }, [props.deviceIdCurrent])

  React.useEffect(() => {
    if (saveDefaultViewObject !== null && saveDefaultViewObject !== undefined) {
      selectedData.current = findWidget(saveDefaultViewObject, 'deviceGraph1')
    } else {
      selectedData.current = null
      setConfigObject(defaultConfigObj)
    }
  }, [saveDefaultViewObject])

  const findWidget = (obj: any, widgetID: string): any => {
    const { assetDashBoardDefaultView } = obj
    const match = assetDashBoardDefaultView.find((widget: any) => widget.widgetId === widgetID)
    return match !== undefined ? match : null
  }

  const getUtcDateRange = (): { today: string, defaultDataWindowUTC: string } => {
    const utcDate = dayjs()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate.utc().subtract(dashboardHours, 'hour').format('YYYY-MM-DD HH:mm:ss')
    return { today, defaultDataWindowUTC }
  }
  const { today, defaultDataWindowUTC } = getUtcDateRange()
  const handleTextChange = (event: any): void => {
    const newValue = event.target.value
    setText(newValue)
    if (selectedData.current !== null) {
      selectedData.current = { ...selectedData.current, displayname: newValue }
    }
    updateTitleOnSaveDefaultObj(newValue, 'deviceGraph1')
  }

  const updateTitleOnSaveDefaultObj = (title: string, widgetID: string): void => {
    const selectedDefaultData = {
      widgetId: widgetID,
      displayname: title,
      devices: [
        {
          deviceId: props.deviceIdCurrent,
          cimCodeIds: [],
          kpidefinitionIds: []
        }
      ],
      assets: []
    }
    updateSaveDefaultObject(saveDefaultViewObject, selectedData.current !== null ? selectedData.current : selectedDefaultData, widgetID)
  }
  const handleBlur = (): void => {
    setIsEditing(false)
  }

  const [reqErrorSave, setReqErrorSave] = React.useState<boolean>(false)
  const [showSuccessPopUp, setshowSuccessPopUp] = React.useState(false)
  const colors: string[] = ['#9AB7FF', '#FFF55D', '#F2752C', '#19CB35']
  const flameSignalDataStatus = useSelector((state: RootState) => state.flameSignalData_NEW)
  const flameSignaGraphKPIData = useSelector((state: RootState) => state.flameSignaGraphKPIData)
  const saveDefaultStatus = useSelector((state: RootState) => state.SaveDefaultViewData)
  const DisplayNameGraph1: any = useSelector((state: RootState) => state.saveDefaultWidgetData.DefaultWidgetData)
  const [chartOptions, setChartOptions] = React.useState<any>({})

  React.useEffect(() => {
    chartComponentRef.current?.chart?.reflow()
  }, [chartComponentRef.current, showAddModal])

  React.useEffect(() => {
    chartComponentRef1.current?.chart?.reflow()
  }, [chartComponentRef1.current, showAddModal])

  React.useEffect(() => {
    const fetchDeviceParamsConfig = async (): Promise<void> => {
      try {
        const res = await viewDeviceService.getDeviceParamsConfig(props.deviceIdCurrent, props.assetTypeID)
        const assetTypeId = res.data.data.filter((res: any) => res.isRegisterEnabled === true && res.isThisFromDefaultConfig === false)
        if (assetTypeId?.length > 0) {
          const SignalOption = assetTypeId.map((item: any) => ({
            value: item.cimCodeId,
            label: item.parameterName,
            unit: item.unit
          }))
          parameterList.current = SignalOption
          setSignalOptions(SignalOption)
        }
      } catch (error) {
        console.log(error)
      }
    }

    const fetchKpiAndParamsList = async (): Promise<void> => {
      try {
        const res = await viewDeviceService.getPerformanceIndicators(props.deviceIdCurrent, props.assetTypeID)
        if (res.data?.data !== undefined) {
          const kpiParams = res.data.data.filter((indicator: any) => indicator.isKpiEnabled === true && indicator.isDefaultConfig === false)
          if (kpiParams.length > 0) {
            const SignalOption = kpiParams.map((item: any) => ({
              value: item.kpiDefinitionId,
              label: item.kpiName,
              unit: item.unit
            }))
            kpiList.current = SignalOption
            setSignalOptions((prevOptions) => [...prevOptions, ...SignalOption])
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    const fetchData = async (): Promise<void> => {
      setSignalOptions([])
      await fetchDeviceParamsConfig()
      await fetchKpiAndParamsList()
    }
    fetchData().catch(error => { console.error(error) })
  }, [props.parentSiteId, props.assetTypeID, props.deviceIdCurrent])

  const [graphDefaultSelectedIds, setGraphDefaultSelectedIds] = React.useState<any>([])

  const getCimCode1 = (data: any, widgetId: string): void => {
    setConfigObject(defaultConfigObj)
    for (const widget of data.assetDashBoardDefaultView) {
      if (widget.widgetId === widgetId) {
        const deviceCimCodeIds = widget.devices.flatMap((device: any) => device.cimCodeIds)
        const deviceKpidefinitionIds = widget.devices.flatMap((device: any) => device.kpidefinitionIds)
        setGraphDefaultSelectedIds([...deviceCimCodeIds, ...deviceKpidefinitionIds])
      }
    }
  }

  useEffect(() => {
    if (graphDefaultSelectedIds.length > 0) {
      const newConfigObject = { ...configObject }

      graphDefaultSelectedIds.forEach((cimCode: any, index: number) => {
        const match = signalOptions.find(item => item.value === cimCode)
        if (match != null) {
          newConfigObject[index + 1] = {
            ...newConfigObject[index + 1],
            selectedSignalData: match,
            checked: true
          }
        }
      })
      setConfigObject(newConfigObject)
    } else {
      setConfigObject(defaultConfigObj)
    }
  }, [graphDefaultSelectedIds, signalOptions])

  const [mergedAssetIntervalReading, setMergedAssetIntervalReading] = React.useState<any>([])

  useEffect(() => {
    if (!checkAllSelectedSignalDataNull() && !flameSignalDataStatus.isLoading && !flameSignaGraphKPIData.isLoading) {
      const flameSignalData = flameSignalDataStatus.flameSignalData
      const flameSignalDataKPI = flameSignaGraphKPIData.flameSignalData
      if (flameSignalData !== null && flameSignalDataKPI !== null) {
        const mergedData = [
          ...flameSignalData.assetIntervalReading,
          ...flameSignalDataKPI[0].assetIntervalReading
        ]
        const options = getChartOptions(mergedData, configObject)
        if ((options?.series ?? [])?.length > 0) { setChartOptions(options) }
        setMergedAssetIntervalReading(mergedData)
      } else if (flameSignalData !== null) {
        const mergedData = [...flameSignalData.assetIntervalReading]
        const options = getChartOptions(mergedData, configObject)
        if ((options?.series ?? [])?.length > 0) { setChartOptions(options) }
        setMergedAssetIntervalReading(mergedData)
      } else if (flameSignalDataKPI !== null) {
        const mergedData = [...flameSignalDataKPI[0].assetIntervalReading]
        const options = getChartOptions(mergedData, configObject)
        if ((options?.series ?? [])?.length > 0) { setChartOptions(options) }
        setMergedAssetIntervalReading(mergedData)
      }
    }
    console.log(mergedAssetIntervalReading)
  }, [flameSignalDataStatus, flameSignaGraphKPIData, configObject])

  const checkAllSelectedSignalDataNull = (): boolean => {
    for (const key in configObject) {
      if (configObject[key].selectedSignalData !== null) {
        return false
      }
    }
    return true
  }

  const isAnySelectedSignalDataNull = (): boolean => {
    for (const key in configObject) {
      if (Object.prototype.hasOwnProperty.call(configObject, key)) {
        if (configObject[key].selectedSignalData === null) {
          return true
        }
      }
    }
    return false
  }

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name } = event.target
    const index = Number(name)
    const newConfigObject = { ...configObject }

    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: newConfigObject[index].checked ? null : newConfigObject[index].selectedSignalData,
      checked: !newConfigObject[index].checked
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleSignalSelection = (selectedValue: Option, index: number): void => {
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      checked: true
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const fetchDataForSelection = (updatedConfigObject: IConfigObject): void => {
    const selectedValuesArray = Object.values(updatedConfigObject)
      .filter(item => item.checked)
      .map(item => item.selectedSignalData?.value)
      .filter(value => value !== undefined)

    const selectedKPIsArr = selectedValuesArray.filter(item => kpiList.current.some((obj: any) => obj.value === item))
    const selectedCimCodeIdsArr = selectedValuesArray.filter(item => parameterList.current.some((obj: any) => obj.value === item))

    const { today, defaultDataWindowUTC } = getUtcDateRange()

    const apiPayloadObj = {
      assetId: props.parentAssetId,
      deviceId: props.deviceIdCurrent,
      cimCodeIds: selectedCimCodeIdsArr.filter((id): id is string => id !== undefined),
      graphName: 'deviceGraph1',
      assetTypeId: props.assetTypeID
    }

    const apiPayloadKPI = {
      assetId: props.parentAssetId,
      deviceId: props.deviceIdCurrent,
      kpiDefinitionIds: selectedKPIsArr.filter((id): id is string => id !== undefined),
      graphName: 'deviceGraph1',
      assetTypeId: props.assetTypeID
    }
    formattedResponseKPIRef.current = {
      assetId: props.parentAssetId,
      devices: [{ deviceId: apiPayloadObj?.deviceId, cimCodeIds: apiPayloadObj?.cimCodeIds, kpidefinitionIds: apiPayloadKPI?.kpiDefinitionIds }],
      assets: []
    }
    props.fetchflameSignalData_NEW(props.startDate === '' ? defaultDataWindowUTC : props.startDate, props.endDate === '' ? today : props.endDate, JSON.stringify(apiPayloadObj), false)
    props.fetchflameKPISignalData(props.startDate === '' ? defaultDataWindowUTC : props.startDate, props.endDate === '' ? today : props.endDate, JSON.stringify(apiPayloadKPI), false)

    if (handleValidation()) {
      const selectedDefaultData = {
        widgetId: 'deviceGraph1',
        displayname: text,
        devices: [
          {
            deviceId: props.deviceIdCurrent,
            cimCodeIds: selectedCimCodeIdsArr.filter((id): id is string => id !== undefined),
            kpidefinitionIds: selectedKPIsArr.filter((id): id is string => id !== undefined)
          }
        ],
        assets: []
      }
      // update savedefault view redux state
      updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, 'deviceGraph1')
    }
  }

  const fetchParamKPIChartData = (isDefault = true, startDate = props.startDate, endDate = props.endDate): void => {
    const { today, defaultDataWindowUTC } = getUtcDateRange()
    const apiPayloadObj = {
      assetId: props.assetTypeID,
      deviceId: props.deviceIdCurrent,
      cimCodeIds: [],
      graphName: 'deviceGraph1',
      assetTypeId: props.assetTypeID
    }

    const apiPayloadKPI = {
      assetId: props.parentAssetId,
      deviceId: props.deviceIdCurrent,
      kpiDefinitionIds: [],
      graphName: 'deviceGraph1',
      assetTypeId: props.assetTypeID
    }

    const selectedDefaultData = {
      widgetId: 'deviceGraph1',
      displayname: text,
      devices: [
        {
          deviceId: props.deviceIdCurrent,
          cimCodeIds: [],
          kpidefinitionIds: []
        }
      ],
      assets: []
    }

    props.fetchflameSignalData_NEW(startDate === '' ? defaultDataWindowUTC : startDate, endDate === '' ? today : endDate, JSON.stringify(apiPayloadObj), isDefault)
    props.fetchflameKPISignalData(startDate === '' ? defaultDataWindowUTC : startDate, endDate === '' ? today : endDate, JSON.stringify(apiPayloadKPI), isDefault)
    updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, 'deviceGraph1')
  }

  const setDisplayname = (data: any, widgetId: string): void => {
    for (const widget of data.assetDashBoardDefaultView) {
      if (widget.widgetId === widgetId) {
        setText(widget.displayname)
        break
      }
    }
  }

  React.useEffect(() => {
    if (typeof DisplayNameGraph1 !== 'undefined') {
      setDisplayname(DisplayNameGraph1, 'deviceGraph1')
      getCimCode1(DisplayNameGraph1, 'deviceGraph1')
    }
  }, [DisplayNameGraph1])

  React.useEffect(() => {
    fetchParamKPIChartData(true, '', '')
    setChartOptions(getChartOptions([], configObject))
    setGraphDefaultSelectedIds([])
  }, [props.deviceIdCurrent])

  const handleValidation = (): boolean => {
    if (configObject[1].checked && configObject[1].selectedSignalData === null) {
      setReqErrorSave(true)
      return false
    }
    if (configObject[2].checked && configObject[2].selectedSignalData === null) {
      setReqErrorSave(true)
      return false
    }
    if (configObject[3].checked && configObject[3].selectedSignalData === null) {
      setReqErrorSave(true)
      return false
    }
    if (configObject[4].checked && configObject[4].selectedSignalData === null) {
      setReqErrorSave(true)
      return false
    }
    return true
  }

  React.useEffect(() => {
    if (props.Golive) {
      formattedResponseKPIRef.current = null
      fetchParamKPIChartData()
    }
  }, [props.Golive])

  React.useEffect(() => {
    if (!props.Golive && props.startDate !== '' && props.endDate !== '') {
      fetchDataForSelection(configObject)
    }
  }, [props.startDate, props.endDate])

  const handleAllCheckboxClick = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const isChecked = event.target.checked
    console.log(isChecked)
    const updatedConfigObject = { ...configObject }
    for (const key in updatedConfigObject) {
      if (Object.prototype.hasOwnProperty.call(updatedConfigObject, key)) {
        updatedConfigObject[key] = {
          ...updatedConfigObject[key],
          selectedSignalData: null,
          checked: false
        }
      }
    }
    if (!isChecked) {
      formattedResponseKPIRef.current = {
        assetId: props.parentAssetId,
        devices: [],
        assets: []
      }
    }
    fetchParamKPIChartData(false)
    setConfigObject(updatedConfigObject)
  }

  const areAllChecked = (): boolean => {
    for (const key in configObject) {
      if (Object.prototype.hasOwnProperty.call(configObject, key)) {
        if (!configObject[key].checked) {
          return false
        }
      }
    }
    return true
  }

  const getSignalGraph = (index: number): JSX.Element => {
    const isLoading = flameSignalDataStatus.isLoading || flameSignaGraphKPIData.isLoading
    const isUnauthorized = flameSignalDataStatus.httpStatus === 401
    const isNoDefaultData =
    flameSignalDataStatus.error === 'No cim code details found for requested graph and asset' &&
    flameSignalDataStatus.httpStatus === 404 &&
    flameSignaGraphKPIData.httpStatus === 404
    const isInvalidDateRange =
    flameSignalDataStatus.error === 'Invalid Date Range' &&
    flameSignalDataStatus.httpStatus === 400
    const isNoParameterSelection =
    flameSignalDataStatus.httpStatus === 204 &&
    flameSignaGraphKPIData.httpStatus === 204
    const isSuccess =
    flameSignalDataStatus.httpStatus === 200 ||
    flameSignaGraphKPIData.httpStatus === 200

    // ✅ Prioritize loading state first
    if (isLoading) {
      return (
      <div className='CircularprogressAmi' style={{ position: 'relative', height: '250px' }}>
        <CircularProgress />
      </div>
      )
    }

    if (isUnauthorized) {
      return (
      <div className='authError flameGraph'>
        <AuthError errorMessage="Unauthorized" />
      </div>
      )
    }

    if (isNoDefaultData) {
      return (
      <div className='authError flameGraph'>
        <AuthError errorMessage="NoDefaultDataPresentGraph" />
      </div>
      )
    }

    if (isInvalidDateRange) {
      return (
      <div className='authError flameGraph date-invalid'>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <span>Invalid Date Range</span>
        </div>
      </div>
      )
    }

    if (isNoParameterSelection) {
      return (
      <div className='authError flameGraph date-invalid'>
        <AuthError errorMessage="NoParameterSelection" />
      </div>
      )
    }

    if (isSuccess) {
      return (
      <HighchartsReact
        highcharts={HighCharts}
        options={chartOptions}
        ref={index === 0 ? chartComponentRef : chartComponentRef1}
      />
      )
    }

    // ✅ Final fallback: Retry only when not loading or matching any known condition
    return (
    <div className='CircularprogressAmi' style={{ position: 'relative', height: '250px' }}>
      <div style={{ marginTop: '16px', textAlign: 'center', width: '325px' }}>
        <div className="authError" >
          <AuthError
            className="paramterError graphError"
            errorMessage="cannotFetch"
            retry= {() => {
              fetchParamKPIChartData(true)
            }}
          />
        </div>
      </div>
    </div>
    )
  }

  const handleclick = (): void => {
    setShowAddModal(true)
    props.stopInterval()
  }

  const handleOkandClose = (): void => {
    if (saveDefaultStatus.httpStatus === 201) {
      setshowSuccessPopUp(false)
    } else {
      setshowSuccessPopUp(false)
    }
  }

  const handleSaveDeafultGraphWithFailure = (): JSX.Element => {
    if (saveDefaultStatus.httpStatus === 201) {
      return (
        <Modal
          buttonTypeNegative='hollow'
          title={'Graph Default Status'}
          LabelPositive={'Ok'}
          onClickPositive={() => { handleOkandClose() }}
          onClose={() => { handleOkandClose() }}
        >
          <p style={{ paddingTop: '1.2em', fontSize: '18px' }}>
            {saveDefaultStatus.httpStatus === 201 ? 'Sucessfullly Updated' : saveDefaultStatus.loadingError}
          </p>
        </Modal>
      )
    } else if (saveDefaultStatus.isLoading) {
      return (
        <Modal title={'Loading...'}>
          <div className='CircularprogressAmi'>
            <CircularProgress />
          </div>
        </Modal>
      )
    } else if (saveDefaultStatus.httpStatus === 400) {
      return (
        <Modal buttonTypeNegative='hollow'
          title={'Graph Default Status'}
          LabelPositive={'Ok'}
          onClickPositive={() => { handleOkandClose() }}
          onClose={() => { handleOkandClose() }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {saveDefaultStatus.loadingError}
          </p>
        </Modal>
      )
    } else if (saveDefaultStatus.httpStatus === 401) {
      return (
        <div className='authError'><AuthError errorMessage='Unauthorized' /></div>
      )
    } else if (saveDefaultStatus.httpStatus === 403) {
      return (
        <div className='authError'><AuthError errorMessage='accessForbidden' /></div>
      )
    } else {
      return (
        <Modal
          buttonTypeNegative='hollow'
          title={'Graph Default Status'}
          LabelPositive={'Ok'}
          onClickPositive={() => {
            setshowSuccessPopUp(false)
          }}
          onClose={() => {
            setshowSuccessPopUp(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {saveDefaultStatus.loadingError}
          </p>
        </Modal>
      )
    }
  }

  DarkUnica(HighCharts)
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card className="device-dashboard-card" style={{ height: '480px' }}>
            <Card className="admin-card-titles device-card-title">
              <Grid container spacing={2} style={{ }}>
                <Grid item xs={7} style={{ display: 'flex' }}>
                 {isEditing
                   ? (
                    <TextField
                      value={text}
                      onChange={handleTextChange}
                      onBlur={handleBlur}
                      autoFocus
                      variant="outlined"
                      size="small"
                      sx={{ input: { color: '#f0f0f0' } }}
                    />
                     )
                   : (
                    <Typography className='title-box' sx={{ color: '#f0f0f0' }}>{text}</Typography>
                     )}
                  <IconButton onClick={handleEditClick} size="small" sx={{ color: '#f0f0f0', marginLeft: '15px', marginTop: '-22px' }}>
                    <img src={EditIcon} />
                  </IconButton>
                </Grid>
                <Grid item xs={5} className="align-text-right">
                  <div className='graphHeader' style={{ display: 'flex' }}>
                  <span ><img src={extentWindow} style={{ cursor: 'pointer', marginTop: '-6px', width: '50px', height: '50px' }} onClick={handleclick}></img></span>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                    <div className="chart-container">
                     {getSignalGraph(0)}
                    </div>
                </Grid>
              </Grid>
            </Card>
          </Card>
        </Grid>
      </Grid>
      { showAddModal && <Modal title='' width='96%' height='auto'>
      <Grid container spacing={1}>
                <Grid item xs={12}>
                <div className='extend-window-title-div'><Typography data-testid='parameter-trends' className='extend-window-title'>Parameter Trends</Typography></div>
                <div className='C-datePicke' style={{ float: 'right', marginTop: '-20px', marginRight: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <MemorizedExport
                    startDateTime={props.startDate === '' ? defaultDataWindowUTC : props.startDate}
                    endDateTime={props.endDate === '' ? today : props.endDate}
                    type={'device'}
                    requestParameter={formattedResponseKPIRef.current ?? {
                      assetId: props.parentAssetId,
                      devices: selectedData.current?.devices ?? [],
                      assets: []
                    }} />
                  <span style={{ marginTop: '0px', cursor: 'pointer', position: 'relative' }} onClick={() => { setShowAddModal(false); props.startInterval() }}>
                    <CloseIcon />
                  </span>
                </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="chart-container" style={{ height: '280px' }}>
                     {getSignalGraph(1)}
                    </div>
                    <div className='chart-title-heading' style={{ textAlign: 'center' }}>
                    </div>
                </Grid>
                  <Grid item xs={12}>
                    <div className='set-Parameter' style={{ textAlign: 'center', marginTop: '80px' }}>
                      <Box className='register-table' p={3}>
                        <Typography variant="h6" style={{ float: 'left', fontFamily: 'Honeywell Sans Web' }}>
                          PARAMETER SETTING
                        </Typography>
                        <Grid container spacing={2} alignItems="left">
                          <Grid item xs={1}>
                            <Checkbox checked={areAllChecked()} onChange={handleAllCheckboxClick} disabled={isAnySelectedSignalDataNull()} className='parameter-checkbox-head' style={{ color: '#D0D0D0' }}/>
                          </Grid>
                          <Grid item xs={1}>
                            <Typography className='table-title'>Colour</Typography>
                          </Grid>
                          <Grid item xs={3}>
                            <Typography className='table-title'>Parameters</Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography className='table-title'>Unit</Typography>
                          </Grid>
                          <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                              <Checkbox checked={configObject[1].checked} onChange={handleCheckBoxChange} name="1" className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={configObject[1].selectedSignalData === null}/>
                            </Grid>
                            <Grid item xs={1}>
                              <Checkbox style={{ color: colors[0], backgroundColor: colors[0], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                            </Grid>
                            <Grid item xs={3}>
                              <GenXDropdown
                                placeholder={'Select Signal'}
                                value={configObject[1].selectedSignalData}
                                options={signalOptions}
                                onSelect={(selectedValue) => { handleSignalSelection(selectedValue, 1) }}
                                width={270}
                              />
                              {reqErrorSave && (configObject[1].checked) && (configObject[1].selectedSignalData === null) && (
                                <div className='error-response'>
                                  <span className='error-upload-message'>{'Select Dropdown'}</span>
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={2}>
                              <Typography>{configObject[1].selectedSignalData?.unit !== null ? configObject[1].selectedSignalData?.unit : '--'}</Typography>
                            </Grid>
                          </Grid>
                          <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                              <Checkbox checked={configObject[2].checked} onChange={handleCheckBoxChange} name="2" className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={configObject[2].selectedSignalData === null}/>
                            </Grid>
                            <Grid item xs={1}>
                              <Checkbox style={{ color: colors[1], backgroundColor: colors[1], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                            </Grid>
                            <Grid item xs={3}>
                              <GenXDropdown
                                placeholder={'Select Signal'}
                                value={configObject[2].selectedSignalData}
                                options={signalOptions}
                                onSelect={(selectedValue) => { handleSignalSelection(selectedValue, 2) }}
                                width={270}
                              />
                              {reqErrorSave && (configObject[2].checked) && (configObject[2].selectedSignalData === null) && (
                                <div className='error-response'>
                                  <span className='error-upload-message'>{'Select Dropdown'}</span>
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={2}>
                              <Typography>{configObject[2].selectedSignalData?.unit !== null ? configObject[2].selectedSignalData?.unit : '--'}</Typography>
                            </Grid>
                          </Grid>
                          <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                              <Checkbox checked={configObject[3].checked} onChange={handleCheckBoxChange} name="3" className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={configObject[3].selectedSignalData === null} />
                            </Grid>
                            <Grid item xs={1}>
                              <Checkbox style={{ color: colors[2], backgroundColor: colors[2], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                            </Grid>
                            <Grid item xs={3}>
                              <GenXDropdown
                                placeholder={'Select Signal'}
                                value={configObject[3].selectedSignalData}
                                options={signalOptions}
                                onSelect={(selectedValue) => { handleSignalSelection(selectedValue, 3) }}
                                width={270}
                              />
                              {reqErrorSave && (configObject[3].checked) && (configObject[3].selectedSignalData === null) && (
                                <div className='error-response'>
                                  <span className='error-upload-message'>{'Select Dropdown'}</span>
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={2}>
                              <Typography>{configObject[3].selectedSignalData?.unit !== null ? configObject[3].selectedSignalData?.unit : '--'}</Typography>
                            </Grid>
                          </Grid>
                          <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                              <Checkbox checked={configObject[4].checked} onChange={handleCheckBoxChange} name="4" className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={ configObject[4].selectedSignalData === null}/>
                            </Grid>
                            <Grid item xs={1}>
                              <Checkbox style={{ color: colors[3], backgroundColor: colors[3], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                            </Grid>
                            <Grid item xs={3}>
                              <GenXDropdown
                                placeholder={'Select Signal'}
                                value={configObject[4].selectedSignalData}
                                options={signalOptions}
                                onSelect={(selectedValue) => { handleSignalSelection(selectedValue, 4) }}
                                width={270}
                              />
                              {reqErrorSave && (configObject[4].checked) && (configObject[4].selectedSignalData === null) && (
                                <div className='error-response'>
                                  <span className='error-upload-message'>{'Select Dropdown'}</span>
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={2}>
                              <Typography>{configObject[4].selectedSignalData?.unit === null ? '--' : configObject[4].selectedSignalData?.unit}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </div>
                  </Grid>
              </Grid>
      </Modal>
      }
      {showSuccessPopUp && handleSaveDeafultGraphWithFailure()}
    </>
  )
}
interface DispatchToProps {
  fetchflameSignalData_NEW: (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => void
  fetchflameKPISignalData: (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => void
  saveDefaultViewDataservice: (deviceId: string, requestParameter: SaveDefaultViewRequest) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  fetchflameSignalData_NEW: (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => dispatch(fetchflameSignalDataNEWONE(startDateTime, endDateTime, request, isDefault)),
  fetchflameKPISignalData: (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => dispatch(fetchflameKPISignalData(startDateTime, endDateTime, request, isDefault)),
  saveDefaultViewDataservice: (deviceId: string, requestParameter: SaveDefaultViewRequest) => dispatch(saveDefaultViewDataservice(deviceId, requestParameter))
})

interface StateToProps {
  flameSignalReadingData: flameSignalReadingDataState
  flameSignalData: IFlameSignalDataState
  flameSignalKPIData: IFlameSignalDataState
  SaveDefaultViewData: SaveDefaultViewDataState
  exportDefaultView: exportDeviceDataGraphDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  flameSignalReadingData: state.flameSignalReadingData,
  flameSignalData: state.flameSignalData_NEW,
  flameSignalKPIData: state.flameSignaGraphKPIData,
  SaveDefaultViewData: state.SaveDefaultViewData,
  exportDefaultView: state.ExportGraphDataState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

interface currentDeviceID {
  deviceIdCurrent: string
  assetTypeID: string
  parentAssetId: string
  parentSiteId: string
  defaultData: any
  saveDefaultViewCall: boolean
  startDate: string
  endDate: string
  Golive: boolean
  stopInterval: any
  startInterval: any
}

type AllProps = PropsFromRedux & currentDeviceID

export default connector(flameSignalGraph)
